import React, { useState } from 'react';
import { Form, FormGroup, Label, Input, Col, Button, Card, CardBody, CardHeader } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';
import { SelectNet } from "../BasicComponents/SelectNet";
import { SelectUnitproxyApply } from "../BasicComponents/SelectUnitproxyApply";
import SelectReport from "../BasicComponents/SelectReport";
import SelectUrlTKBG from "../BasicComponents/SelectUrlTKBG";

import SelectTenableNet from "../BasicComponents/SelectTenableNet";
import SelectTenableUnit from "../BasicComponents/SelectTenableUnit";
import SelectTenableUrl from "../BasicComponents/SelectTenableUrl";
import SelectTenableReport from "../BasicComponents/SelectTenableReport";


import { api_url, loginInfo } from "../globalFunction/global_string";
import { FaTrash } from 'react-icons/fa';
import withReactContent from 'sweetalert2-react-content';

const riskLevelMapping = {
    '重要': 5,
    '高': 4,
    '中': 3,
    '低': 2,
    '資訊': 1
};
function CreateTenableList() {
    const [formValues, setFormValues] = useState({
        projectName: '',
        projectStartTime: '',
        projectEndTime: '',
        riskLevels: [5, 4, 3], // 預設選中"高"和"中"
        selectedDuration: '1',
        isSubmitted: false
    });

    const MySwal = withReactContent(Swal);

    const [selectedNet, setSelectedNet] = useState('');
    const [localNetName, setLocalNetName] = useState('');
    const [selectedUnit, setSelectedUnit] = useState('');
    const [localUnitName, setLocalUnitName] = useState('');
    const [selectedUrl, setSelectedUrl] = useState('');
    const [localUrlName, setLocalUrlName] = useState('');
    const [selectreport, setSelectreport] = useState("");
    const [local_report_name, setLocal_report_name] = useState("");
    const [net_name, setNetName] = useState(localStorage.getItem('login_user_net_name'));
    const [unit_name, setUnitName] = useState(localStorage.getItem('login_local_unit_name'));
    const [userType, setuserType] = useState(localStorage.getItem('login_user_type'));

    const [trackingReports, setTrackingReports] = useState([
        { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
    ]);


    // 處理表單輸入變更
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === 'projectEndTime' && new Date(value) < new Date(formValues.projectStartTime)) {
            Swal.fire({
                title: '錯誤!',
                text: '追蹤計畫結束時間不能小於開始時間',
                icon: 'error',
                confirmButtonText: '好的'
            });
            return;
        }

        setFormValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    };

    // 處理風險等級變更
    const handleRiskLevelChange = (event) => {
        const { value } = event.target;
        const numValue = riskLevelMapping[value];
        setFormValues(prevValues => ({
            ...prevValues,
            riskLevels: prevValues.riskLevels.includes(numValue)
                ? prevValues.riskLevels.filter(level => level !== numValue)
                : [...prevValues.riskLevels, numValue].sort((a, b) => a - b)
        }));
    };

    // 處理網路選擇變更
    const handleNetSelectChange = (data, index) => {
        const { value, selectedName } = data;
        console.log('Net Selected:', { value, selectedName, index });

        const updatedReports = [...trackingReports];
        updatedReports[index].selectNet = value;
        updatedReports[index].local_net_name = selectedName;
        updatedReports[index].selectUnit = ''; // 重置單位選擇
        updatedReports[index].local_unit_name = '';
        setTrackingReports(updatedReports);
    };

    // 處理單位選擇變更
    const handleUnitSelectChange = (data, index) => {
        const { value, selectedName } = data;
        console.log('Unit Selected:', { value, selectedName, index });

        const updatedReports = [...trackingReports];
        updatedReports[index].selectUnit = value;
        updatedReports[index].local_unit_name = selectedName;
        setTrackingReports(updatedReports);
    };

    // 處理 URL 選擇變更
    const handleUrlSelectChange = (data, index) => {
        const { value, selectedName } = data;
        console.log('URL Selected:', { value, selectedName, index });

        const updatedReports = [...trackingReports];
        updatedReports[index].selectUrl = value; // 更新選擇的 URL 或 Host
        updatedReports[index].local_Url_name = selectedName; // 更新選擇的名稱 (IP 地址)
        updatedReports[index].selectedHostIp = selectedName; // 更新選擇的主機 IP
        setTrackingReports(updatedReports);
    };

    // 處理報告選擇
    const selectReport = (data, index) => {
        setSelectreport(data.value);

        const updatedReports = [...trackingReports];
        updatedReports[index].selectReport = data.value;
        updatedReports[index].local_report_name = data.selectedName;

        setTrackingReports(updatedReports);
        console.log('更新後的追蹤報告清單:', updatedReports);
    };




    //報告時間
    const durationOptions = [
        { label: '1個月', value: '1' },
        { label: '3個月', value: '3' },
        { label: '6個月', value: '6' },
        { label: '一年', value: '12' },
        { label: '二年', value: '24' },
        { label: '三年', value: '36' },
    ];


    // 新增追蹤報告
    const addTrackingReport = () => {
        setTrackingReports([
            ...trackingReports,
            { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
        ]);
    };
    // 更新指定追蹤報告的資料
    const updateTrackingReport = (index, field, value) => {
        const updatedReports = trackingReports.map((report, i) => {
            if (i === index) {
                return { ...report, [field]: value };
            }
            return report;
        });
        setTrackingReports(updatedReports);
    };
    const removeTrackingReport = (index) => {
        setTrackingReports(prevReports => prevReports.filter((_, i) => i !== index));
    };

    const handleSave = async () => {
        // 驗證邏輯
        const validateForm = () => {
            if (formValues.projectName.trim() === '') {
                Swal.fire('錯誤', '請填寫專案名稱', 'error');
                return false;
            }

            if (formValues.projectStartTime === '' || formValues.projectEndTime === '') {
                Swal.fire('錯誤', '請填寫追蹤計畫開始時間和結束時間', 'error');
                return false;
            }

            if (new Date(formValues.projectEndTime) < new Date(formValues.projectStartTime)) {
                Swal.fire('錯誤', '結束追蹤時間不能早於追蹤時間', 'error');
                return false;
            }

            if (formValues.riskLevels.length === 0) {
                Swal.fire('錯誤', '請至少選擇一個風險等級', 'error');
                return false;
            }

            console.log(trackingReports)
            if (trackingReports.length === 0 || trackingReports.some(report => report.local_report_name.trim() === '')) {
                Swal.fire('錯誤', '請至少新增一個追蹤報告', 'error');
                return false;
            }

            const selectHostIpSet = new Set();
            for (const report of trackingReports) {
                if (selectHostIpSet.has(report.selecthost_ip)) {
                    Swal.fire('錯誤', '追蹤報告中有重複的主機 IP', 'error');
                    return false;
                }
                selectHostIpSet.add(report.selecthost_ip);
            }

            return true;
        };

        if (!validateForm()) return;

        let apiUrl = api_url + '/api/TrackBackground/post-ten-track-list';
        let currentDateTime = new Date().toISOString();
        let allReportsSubmittedSuccessfully = true;

        for (const report of trackingReports) {
            const formData = new FormData();

            ['Heavy', 'High', 'Medium', 'Low', 'Information'].forEach((risk, index) => {
                formData.set(`project${risk}Risk`, formValues.riskLevels.includes(5 - index) ? 'true' : 'false');
            });

            formData.set('projectName', formValues.projectName);
            formData.set('projectStartTime', formValues.projectStartTime);
            formData.set('projectEndTime', formValues.projectEndTime);
            formData.set('selectedDuration', formValues.selectedDuration);
            formData.set('user_type', localStorage.getItem('login_user_type'));
            formData.set('local_net_id', localStorage.getItem('login_user_net_id'));
            formData.set('local_unit_id', localStorage.getItem('login_user_unit_id'));

            // 根據使用者類型設置相關欄位
            const userTypeMap = {
                'S': () => {
                    formData.set('projectnet', report.selectNet);
                    formData.set('projectunit', report.selectUnit);
                    formData.set('IsadminbuildTrack', 'true');
                    formData.set('IsadminTrack', 'true');
                },
                'M': () => {
                    formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                    formData.set('projectunit', report.selectUnit);
                    formData.set('IsNetbuildTrack', 'true');
                    formData.set('IsNetTrack', 'true');
                },
                'N': () => {
                    formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                    formData.set('projectunit', localStorage.getItem('login_user_unit_id'));
                    formData.set('IsUnitbuildTrack', 'true');
                    formData.set('IsUnitTrack', 'true');
                }
            };
            userTypeMap[userType]?.();

            formData.set('projecturl', report.selectUrl);
            formData.set('projecturlname', report.local_Url_name);
            formData.set('projectllimit', report.selectedDuration);

            // 使用 selecthost_ip 替代 selectReport
            formData.set('projectreport', report.selectReport);
            formData.set('projectreportname', report.local_report_name);

            formData.set('projectTemporarilySave', 'true');
            formData.set('build_date', formatDateTime(currentDateTime));

            // 統一設置
            formData.set('IsadminTrack', formData.get('IsadminTrack') || 'false');
            formData.set('IsNetTrack', formData.get('IsNetTrack') || 'false');
            formData.set('IsUnitTrack', formData.get('IsUnitTrack') || 'false');

            MySwal.fire({
                title: '處理中...',
                text: '報告建置中',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                    MySwal.showLoading();
                }
            });

            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Authorization": localStorage.getItem('accessToken') },
                    body: formData
                });
                const data = await response.json();
                console.log(data.result.statusCode);
            } catch (error) {
                allReportsSubmittedSuccessfully = false;
                console.error('提交錯誤:', error);
            }
        }

        MySwal.close();

        if (allReportsSubmittedSuccessfully) {
            Swal.fire({
                title: '成功!',
                text: '所有追蹤報告儲存成功，您可以去追蹤清單查看',
                icon: 'success',
                confirmButtonText: '好的'
            }).then(() => {
                // 重置表單和報告狀態
                setFormValues({
                    projectName: '',
                    projectStartTime: '',
                    projectEndTime: '',
                    riskLevels: [5, 4, 3],
                    selectedDuration: '1',
                    isSubmitted: false,
                });

                setTrackingReports([{
                    selectNet: '',
                    selectUnit: '',
                    selectUrl: '',
                    selectReport: '',
                    local_net_name: '',
                    local_unit_name: '',
                    local_Url_name: '',
                    local_report_name: '',
                    selectedDuration: '1',
                    selectedHostIp: '',
                }]);
            });
        }
    };



    const handleSubmit = async (event) => {
        event.preventDefault();

        // 驗證邏輯封裝
        const validateForm = () => {
            if (formValues.projectName.trim() === '') {
                Swal.fire('錯誤', '請填寫專案名稱', 'error');
                return false;
            }

            if (formValues.projectStartTime === '' || formValues.projectEndTime === '') {
                Swal.fire('錯誤', '請填寫追蹤計畫開始時間和結束時間', 'error');
                return false;
            }

            if (new Date(formValues.projectEndTime) < new Date(formValues.projectStartTime)) {
                Swal.fire('錯誤', '結束追蹤時間不能早於追蹤時間', 'error');
                return false;
            }

            if (formValues.riskLevels.length === 0) {
                Swal.fire('錯誤', '請至少選擇一個風險等級', 'error');
                return false;
            }

            if (trackingReports.length === 0 || trackingReports.some(report => report.selecthost_ip.trim() === '')) {
                Swal.fire('錯誤', '請至少新增一個追蹤報告', 'error');
                return false;
            }

            const selectReportSet = new Set();
            for (const report of trackingReports) {
                if (selectReportSet.has(report.selecthost_ip)) {
                    Swal.fire('錯誤', '追蹤報告中有重複的報告', 'error');
                    return false;
                }
                selectReportSet.add(report.selecthost_ip);
            }

            return true;
        };

        if (!validateForm()) return;

        const confirmSubmit = await Swal.fire({
            title: '確定提交報告?',
            text: '提交後內容將無法更改',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '確定',
            cancelButtonText: '取消'
        }).then(result => result.isConfirmed);

        if (!confirmSubmit) return;

        let apiUrl = api_url + '/api/TrackBackground/post-ten-track-list';
        let currentDateTime = new Date().toISOString();
        let allReportsSubmittedSuccessfully = true;

        for (const report of trackingReports) {
            const formData = new FormData();

            // 封裝風險等級設置
            ['Heavy', 'High', 'Medium', 'Low', 'Information'].forEach((risk, index) => {
                formData.set(`project${risk}Risk`, formValues.riskLevels.includes(5 - index) ? 'true' : 'false');
            });

            formData.set('projectName', formValues.projectName);
            formData.set('projectStartTime', formValues.projectStartTime);
            formData.set('projectEndTime', formValues.projectEndTime);
            formData.set('selectedDuration', formValues.selectedDuration);
            formData.set('user_type', loginInfo.login_user_type);
            formData.set('local_net_id', loginInfo.login_user_net_id);
            formData.set('local_unit_id', loginInfo.login_user_unit_id);

            // 根據使用者類型設置相關欄位
            const userTypeMap = {
                'S': () => {
                    formData.set('projectnet', report.selectNet);
                    formData.set('projectunit', report.selectUnit);
                    formData.set('IsadminbuildTrack', 'true');
                    formData.set('IsadminTrack', 'true');
                },
                'M': () => {
                    formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                    formData.set('projectunit', report.selectUnit);
                    formData.set('IsNetbuildTrack', 'true');
                    formData.set('IsNetTrack', 'true');
                },
                'N': () => {
                    formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                    formData.set('projectunit', localStorage.getItem('login_user_unit_id'));
                    formData.set('IsUnitbuildTrack', 'true');
                    formData.set('IsUnitTrack', 'true');
                }
            };
            userTypeMap[userType]?.();  // 使用映射簡化分支

            formData.set('projecturl', report.selectUrl);
            formData.set('projecturlname', report.local_Url_name);
            formData.set('projectllimit', report.selectedDuration);

            // 使用 selecthost_ip 替代 selectReport
            formData.set('projectreport', report.selecthost_ip);
            formData.set('projectreportname', report.local_report_name);

            formData.set('projectStore', 'true');
            formData.set('build_date', formatDateTime(currentDateTime));

            // 統一設定
            formData.set('IsadminTrack', formData.get('IsadminTrack') || 'false');
            formData.set('IsNetTrack', formData.get('IsNetTrack') || 'false');
            formData.set('IsUnitTrack', formData.get('IsUnitTrack') || 'false');

            MySwal.fire({
                title: '處理中...',
                text: '報告建置中',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                    MySwal.showLoading();
                }
            });

            for (const key in report) {
                formData.append(key, report[key]);
            }

            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Authorization": localStorage.getItem('accessToken') },
                    body: formData
                });
                const data = await response.json();
                console.log(data.result.statusCode);
            } catch (error) {
                allReportsSubmittedSuccessfully = false;
                console.error('提交錯誤:', error);
            }
        }

        MySwal.close();

        if (allReportsSubmittedSuccessfully) {
            Swal.fire({
                title: '成功!',
                text: '所有追蹤報告儲存成功，您可以去追蹤清單查看',
                icon: 'success',
                confirmButtonText: '好的'
            });

            setFormValues({
                projectName: '',
                projectStartTime: '',
                projectEndTime: '',
                riskLevels: [5, 4, 3],
                selectedDuration: '1',
                isSubmitted: false,
            });
            setTrackingReports([
                { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
            ]);
        }
    };


    function formatDateTime(isoString) {
        const date = new Date(isoString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    }

    const renderTrackingReportForms = () => {
        return trackingReports.map((report, index) => (
            <Card key={index}>
                <CardHeader className="d-flex justify-content-between align-items-center">
                    追蹤報告 #{index + 1}
                    {index > 0 && (
                        <Button color="danger" onClick={() => removeTrackingReport(index)}>
                            <FaTrash />
                        </Button>
                    )}
                </CardHeader>
                <CardBody>
                    {renderFormDataUsertype(report, index)}
                </CardBody>
            </Card>
        ));
    };

    const renderFormDataUsertype = (report, index) => {
        if (userType === 'S') {
            return (
                <>
                    <FormGroup row>
                        <Label for={`local_net_id_${index}`} sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <SelectTenableNet
                                parentName={'superS'}
                                id={`excel_net_name_${index}`}
                                name={`excel_net_name_${index}`}
                                requiredAPI={'/api/JRCC/GetLocalNetId'}
                                handleNetSelectChange={(data) => handleNetSelectChange(data, index)}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_unit_proxy_name_${index}`} sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUnit
                                parentName={'superS'}
                                id={`excel_unit_proxy_name_${index}`}
                                name={`excel_unit_proxy_name_${index}`}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                handleUnitSelectChange={(data) => handleUnitSelectChange(data, index)} // 確保函數名稱正確
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>主機名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUrl
                                parentName={'superS'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                onChange={(data) => handleUrlSelectChange(data, index)}
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                                selectedUnit={report.selectUnit}
                                local_unit_name={report.local_unit_name}

                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>選擇時間範圍:</Label>
                        <Col sm={10}>
                            <Input
                                type="select"
                                name={`selectedDuration_${index}`}
                                value={report.selectedDuration}
                                onChange={(e) => updateTrackingReport(index, 'selectedDuration', e.target.value)}
                            >
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_report_list_${index}`} sm={2}>報告名稱</Label>
                        <Col sm={10}>
                            <SelectTenableReport
                                parentName={'superS'}
                                id={`excel_report_list_${index}`}
                                name={`excel_report_list_${index}`}
                                requiredAPI={'/api/TrackBackground/GetTenableReportlist'}
                                selectReport={(data) => selectReport(data, index)}
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                                selectUrl={report.selectUrl}
                                selecthost_ip={report.selectedHostIp}  // 傳入已選擇的主機 IP
                                selectedDuration={report.selectedDuration}
                            />
                        </Col>
                    </FormGroup>
                </>
            );
        } else if (userType === 'M') {
            return (
                <>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{net_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_unit_proxy_name_${index}`} sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUnit
                                parentName={'superM'}
                                id={`excel_unit_proxy_name_${index}`}
                                name={`excel_unit_proxy_name_${index}`}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                handleUnitSelectChange={(data) => handleUnitSelectChange(data, index)}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>主機名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUrl
                                parentName={'superM'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                onChange={(data) => handleUrlSelectChange(data, index)}
                                selectedUnit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>選擇時間範圍:</Label>
                        <Col sm={10}>
                            <Input
                                type="select"
                                name={`selectedDuration_${index}`}
                                value={report.selectedDuration}
                                onChange={(e) => updateTrackingReport(index, 'selectedDuration', e.target.value)}
                            >
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_report_list_${index}`} sm={2}>報告名稱</Label>
                        <Col sm={10}>
                            <SelectTenableReport
                                parentName={'superM'}
                                id={`excel_report_list_${index}`}
                                name={`excel_report_list_${index}`}
                                requiredAPI={'/api/TrackBackground/GetTenableReportlist'}
                                selectReport={(data) => selectReport(data, index)}
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                                selectUrl={report.selectUrl}
                                selecthost_ip={report.selectedHostIp}  // 傳入已選擇的主機 IP
                                selectedDuration={report.selectedDuration}
                                selectedReport={report.selectedReport} // 新增這一行，傳遞選中的報告
                            />
                        </Col>
                    </FormGroup>
                </>
            );
        } else if (userType === 'N') {
            return (
                <>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{net_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{unit_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>主機名稱</Label>
                        <Col sm={10}>
                            <SelectTenableUrl
                                parentName={'superN'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                onChange={(data) => handleUrlSelectChange(data, index)}
                                selectedUnit={localStorage.getItem('login_user_unit_id')}
                                local_unit_name={unit_name}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>選擇時間範圍:</Label>
                        <Col sm={10}>
                            <Input
                                type="select"
                                name={`selectedDuration_${index}`}
                                value={report.selectedDuration}
                                onChange={(e) => updateTrackingReport(index, 'selectedDuration', e.target.value)}
                            >
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_report_list_${index}`} sm={2}>報告名稱</Label>
                        <Col sm={10}>
                            <SelectTenableReport
                                parentName={'superN'}
                                id={`excel_report_list_${index}`}
                                name={`excel_report_list_${index}`}
                                requiredAPI={'/api/TrackBackground/GetTenableReportlist'}
                                selectReport={(data) => selectReport(data, index)}
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                                selectUrl={report.selectUrl}
                                selecthost_ip={report.selectedHostIp}  // 傳入已選擇的主機 IP
                                selectedDuration={report.selectedDuration}
                                selectedReport={report.selectedReport} // 新增這一行，傳遞選中的報告
                            />
                        </Col>
                    </FormGroup>
                </>
            );
        }
    }


    return (
        <div>
            <Form onSubmit={handleSubmit}>
                <FormGroup row>
                    <Label for="projectName" sm={2}>追蹤計畫名稱:</Label>
                    <Col sm={10}>
                        <Input
                            type="text"
                            name="projectName"
                            id="projectName"
                            value={formValues.projectName}
                            onChange={handleInputChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="projectStartTime" sm={2}>追蹤計畫開始時間:</Label>
                    <Col sm={10}>
                        <Input
                            type="date"
                            name="projectStartTime"
                            id="projectStartTime"
                            min={new Date().toISOString().split('T')[0]}
                            value={formValues.projectStartTime}
                            onChange={handleInputChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="projectEndTime" sm={2}>追蹤計畫結束時間:</Label>
                    <Col sm={10}>
                        <Input
                            type="date"
                            name="projectEndTime"
                            id="projectEndTime"
                            min={new Date().toISOString().split('T')[0]}
                            value={formValues.projectEndTime}
                            onChange={handleInputChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={2}>風險層級:</Label>
                    <Col sm={10}>
                        <div className="d-flex flex-row">
                            {Object.entries(riskLevelMapping).map(([key, numValue]) => (
                                <FormGroup check inline key={key}>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            name="riskLevels"
                                            value={key}
                                            checked={formValues.riskLevels.includes(numValue)}
                                            onChange={handleRiskLevelChange}
                                        />
                                        {key}
                                    </Label>
                                </FormGroup>
                            ))}
                        </div>
                    </Col>
                </FormGroup>
                {renderTrackingReportForms()}
                <Button onClick={addTrackingReport} color="success">新增追蹤報告</Button>
                {' '}
                <Button onClick={handleSave} color="secondary" >
                    儲存
                </Button>
                {' '}
                {/* <Button type="submit" color="primary" >
                    提交
                </Button> */}
            </Form>
        </div>
    );
}

export default CreateTenableList;
